module.exports = "<div class=\"dbm-list-box\">\n    <ul>\n        <li *ngFor=\"let item of listItems\">\n            <div class=\"dbm-list-box-item\">\n                <i class=\"dbm dbm-remove-icon cursor\" (click)=\"onListItemDelete.emit(item)\"></i>\n                <span>{{item.name}}</span>\n            </div>\n        </li>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dbm-components/dbm-box-list/dbm-box-list.component.html
// module id = 1884
// module chunks = 0